document.addEventListener("DOMContentLoaded", function () {
  const swipers = [];

  document
    .querySelectorAll(".product-content .product-video-swiper")
    .forEach((swiperEl) => {
      const swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: swiperEl.querySelector(".swiper-button-next"),
          prevEl: swiperEl.querySelector(".swiper-button-prev"),
        },
        pagination: {
          el: swiperEl.querySelector(".swiper-pagination"),
          type: "fraction",
        },
        on: {
          slideChangeTransitionStart: function () {
            pauseAllVideos();
          },
        },
      });

      swipers.push({
        el: swiperEl,
        instance: swiper,
      });
    });

  const navItems = document.querySelectorAll(
    ".common-product-with-video .nav-item"
  );

  const products = document.querySelectorAll(
    ".common-product-with-video .product-content"
  );

  function pauseAllVideos() {
    const iframes = document.querySelectorAll(
      ".common-product-with-video .product-video-swiper iframe"
    );

    iframes.forEach((iframe) => {
      try {
        iframe.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          "*"
        );
      } catch (e) {}
    });
  }

  function loadYouTubeVideo(wrapper) {
    if (!wrapper) return;

    if (wrapper.querySelector("iframe")) return;

    const videoId = wrapper.getAttribute("data-youtube-id");

    if (!videoId) return;

    pauseAllVideos();

    const iframe = document.createElement("iframe");

    iframe.src =
      "https://www.youtube.com/embed/" +
      encodeURIComponent(videoId) +
      "?rel=0" +
      "&showinfo=0" +
      "&modestbranding=1" +
      "&enablejsapi=1" +
      "&autoplay=1" +
      "&loop=1" +
      "&playlist=" +
      encodeURIComponent(videoId);

    iframe.title = "YouTube video";
    iframe.frameBorder = "0";

    iframe.allow =
      "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";

    iframe.allowFullscreen = true;
    iframe.loading = "eager";

    const placeholder = wrapper.querySelector(
      ".youtube-video-placeholder"
    );

    if (placeholder) {
      placeholder.style.display = "none";
    }

    wrapper.appendChild(iframe);
  }

  document
    .querySelectorAll(".youtube-video-placeholder")
    .forEach((placeholder) => {
      placeholder.addEventListener("click", function () {
        const wrapper = this.closest(".youtube-video-wrapper");

        loadYouTubeVideo(wrapper);
      });
    });

  function activateProduct(index) {
    if (index < 0) {
      index = navItems.length - 1;
    }

    if (index >= navItems.length) {
      index = 0;
    }

    pauseAllVideos();

    navItems.forEach((item) => {
      item.classList.remove("active");
    });

    products.forEach((content) => {
      content.classList.remove("active");
    });

    const activeItem = navItems[index];

    if (!activeItem) return;

    const targetProduct = activeItem.getAttribute("data-product");

    const target = document.querySelector(
      `.product-content[data-product="${targetProduct}"]`
    );

    activeItem.classList.add("active");

    if (target) {
      target.classList.add("active");

      syncHeight();
      updateThumbnail();

      const swiperData = swipers.find(
        (item) => item.el === target.querySelector(".swiper")
      );

      if (swiperData) {
        swiperData.instance.update();
      }
    }

    activeItem.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "start",
    });
  }

  navItems.forEach((item, index) => {
    item.addEventListener("click", function () {
      activateProduct(index);
      updateDisableClass();
    });
  });

  const prevBtn = document.querySelector(
    ".common-product-with-video .nav-btn .icon-swiper-prev"
  );

  const nextBtn = document.querySelector(
    ".common-product-with-video .nav-btn .icon-swiper-next"
  );

  function getActiveIndex() {
    return Array.from(navItems).findIndex((item) =>
      item.classList.contains("active")
    );
  }

  prevBtn?.addEventListener("click", function () {
    const current = getActiveIndex();

    if (current > 0) {
      activateProduct(current - 1);
    }

    updateDisableClass();
  });

  nextBtn?.addEventListener("click", function () {
    const current = getActiveIndex();

    if (current < navItems.length - 1) {
      activateProduct(current + 1);
    }

    updateDisableClass();
  });

  function updateDisableClass() {
    const current = getActiveIndex();

    if (current <= 0) {
      prevBtn?.classList.add("disable");
    } else {
      prevBtn?.classList.remove("disable");
    }

    if (current >= navItems.length - 1) {
      nextBtn?.classList.add("disable");
    } else {
      nextBtn?.classList.remove("disable");
    }
  }

  function syncHeight() {
    const left = document.querySelector(
      ".product-content.active .thumbnail-wrapper"
    );

    const right = document.querySelector(
      ".product-content.active .grid-product"
    );

    if (!left || !right) return;

    left.style.height = "0px";
    left.style.height = right.offsetHeight + "px";
  }

  function updateThumbnail() {
    const activeContent = document.querySelector(
      ".common-product-with-video .product-content.active"
    );

    if (!activeContent) return;

    const thumbnails = activeContent.querySelectorAll(".thumbnail");
    const mainImage = activeContent.querySelector(".product--image");

    thumbnails.forEach((thumbnail) => {
      if (thumbnail.dataset.thumbnailBound === "true") return;

      thumbnail.dataset.thumbnailBound = "true";

      thumbnail.addEventListener("click", function () {
        thumbnails.forEach((item) => {
          item.classList.remove("active");
        });

        thumbnail.classList.add("active");

        const container = thumbnail.closest(".thumbnail-wrapper");

        if (container) {
          const top = thumbnail.offsetTop - container.offsetTop;

          container.scrollTo({
            top,
            behavior: "smooth",
          });
        }

        const newSrc = thumbnail.getAttribute("src");

        if (mainImage && newSrc) {
          mainImage.removeAttribute("srcset");
          mainImage.removeAttribute("data-srcset");
          mainImage.removeAttribute("data-src");
          mainImage.removeAttribute("sizes");

          mainImage.style.transition = "opacity 0.3s ease";
          mainImage.style.opacity = "0";

          setTimeout(() => {
            mainImage.setAttribute("src", newSrc);
            mainImage.style.opacity = "1";
          }, 50);
        }
      });
    });
  }

  updateDisableClass();
  updateThumbnail();

  window.addEventListener("load", function () {
    syncHeight();
  });

  window.addEventListener("resize", function () {
    syncHeight();
  });
});